import React from "react";

export default function Documents() {
  return (
    <div>
      <div className="balanceBox">
        <div className="balanceBoxInner bg-light">
          <h2 className="balanceBoxTitle text-center text-dark">Documents</h2>
        </div>
      </div>
    </div>
  );
}
